import { render, staticRenderFns } from "./DisablePromoCode.vue?vue&type=template&id=575c82ee"
import script from "./DisablePromoCode.vue?vue&type=script&lang=ts"
export * from "./DisablePromoCode.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports